import React from 'react';
import { Box, Container, Heading, Text } from '@qga/roo-ui/components';
import PropTypes from 'prop-types';

import DocumentTitle from '@/components/DocumentTitle';
import Layout from '@/components/Layout';
import MetaDescription from '@/components/MetaDescription';
import Page from '@/components/Page';
import FaqCategory from '@/propTypes/FaqCategory';
import DestinationLinks from '@/v2/components/ui/SiteFooter/components/DestinationLinks';
import usePageViewEvent from '@/v2/hooks/usePageViewEvent';
import AllCategories from './components/AllCategories';
import DataLayer from './components/DataLayer';
import PopularCategories from './components/PopularCategories';

const FaqsPage = ({ categories }) => {
  usePageViewEvent({ type: 'faq' });

  return (
    <Layout>
      <DataLayer />
      <DocumentTitle>Frequently Asked Questions</DocumentTitle>
      <MetaDescription
        // eslint-disable-next-line max-len
        content="Visit our Frequently Asked Questions page to get more information about Qantas Holidays."
      />
      <Page data-testid="FAQS_PAGE">
        <Box bg="white" py={['9', null, '18']}>
          <Container>
            <Heading.h1>Frequently Asked Questions</Heading.h1>
            <Text>
              Can&apos;t find the information you&apos;re after? Browse our
              Qantas Holidays FAQs for more help.
            </Text>
          </Container>
        </Box>
        {categories && (
          <>
            <PopularCategories
              categories={categories.filter((c) => c.isPopular)}
            />
            <AllCategories categories={categories} />
          </>
        )}
      </Page>
      <DestinationLinks />
    </Layout>
  );
};

FaqsPage.propTypes = {
  categories: PropTypes.arrayOf(PropTypes.shape(FaqCategory)),
};

export default FaqsPage;
